import 'select2';
import 'select2/dist/css/select2';
import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    $('select.bank-list').select2();
  }
}